import { SupportModal } from '@/components/modals';
import { HelpSlideOver } from '@/components/slideOvers_v2/helpSlideOver';
import { useModalContext } from '@/hooks/useModalContext';
import { useSlideOverContext } from '@/hooks/useSlideOverContext';
import { Stepper } from '@/lib/Steppers';
import { SLIDEOVER_TRANSITION_DURATION } from '@/providers';
import { delay } from 'lodash';
import { FC } from 'react';
import { CREATE_CAMPAIGN_STEPS } from '../constants';
import { useCampaignsValues } from '../context';
import { useCreateCampaignStepHints } from '../hooks';
import { ConnectAudienceStep, DataSourceStep, NewCampaignStep, SelectAudienceStep } from './steps';
import { DestinationStep } from './steps/DestinationStep';

export const CreateCampaignContent: FC = () => {
  const { currentStep } = useCampaignsValues();

  const { openSlideOver, closeSlideOver } = useSlideOverContext();
  const { openModal } = useModalContext();

  const { hints, totalHints } = useCreateCampaignStepHints(currentStep.id);

  const onRequestSupport = () => {
    closeSlideOver();
    delay(() => {
      openModal({
        renderContent: SupportModal,
        renderContentProps: {},
      });
    }, SLIDEOVER_TRANSITION_DURATION);
  };

  const handleHelpClick = () => {
    if (totalHints > 0) {
      openSlideOver({
        renderContent: HelpSlideOver,
        renderContentProps: { hints: hints, onRequestSupport: onRequestSupport },
        showButtonInsideSlideOver: true,
      });
    }
  };

  return (
    <div className='flex grow flex-col gap-20 pt-10'>
      <div className='flex gap-24 px-12'>
        <Stepper steps={CREATE_CAMPAIGN_STEPS} currentStep={currentStep} />
      </div>

      {currentStep.id === 'CreateNewCampaign' && <NewCampaignStep />}
      {currentStep.id === 'ImportDataSource' && <DataSourceStep />}
      {currentStep.id === 'ChooseDestination' && <DestinationStep />}
      {currentStep.id === 'SelectAudience' && <SelectAudienceStep />}
      {currentStep.id === 'ConnectAudience' && <ConnectAudienceStep />}
    </div>
  );
};
